import { useEffect } from 'react';
import { useStore } from '@tmsw/powerups.store';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import { CTAButton } from '@tmsw/powerups.ui.buttons.cta-button';
import './Disclaimer.css';

export const Disclaimer = ({ goToNextPage }) => {
  const { __t } = useTranslation('DISCLAIMER', {
    defaultToKey: true,
  });
  const setSkipTarget = useStore((state) => state.setSkipTarget);
  const setBackTarget = useStore((state) => state.setBackTarget);
  console.log(
    'DISCLAIMERs style',
    __t('style', { background: Object.values(__t('backgrounds', 'GENERAL')) })
  );
  const setPageTitle = useStore((state) => state.setPageTitle);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const inPortrait = useStore((state) => state.inPortrait);

  const disclaimerBodyCopy = `${__t('header')} \n\n ${__t('callout-a11y')}`;
  useEffect(() => {
    setBackTarget(null);
    setSkipTarget(null);
  }, [setBackTarget, setSkipTarget]);

  useEffect(() => {
    setPageTitle(__t('pageTitle'));
  }, [showSettingsPanel, isPauseEnabled, inPortrait]);

  return (
    <section
      className="disclaimer-section"
      style={{
        backgroundImage: `url(${__t('backgrounds.vignette', 'GENERAL')})`,
      }}
    >
      <div className="disclaimer-content">
        <img
          src={__t('logos.primary', 'GENERAL')}
          alt={__t('logoImageAlt', 'GENERAL')}
          className="disclaimer-logo-img"
        />
        <h1 className="HeaderH1">{__t('warning')}</h1>

        <div className="disclaimer-body-copy">
          <p className="HeaderH2">{disclaimerBodyCopy}</p>
        </div>
        <ul className="cta-btn-list disclaimer-btn-list">
          <li>
            <CTAButton
              primary
              onClick={goToNextPage}
              label={__t('buttons.playGame.label', 'GENERAL')}
              ariaLabel={__t('buttons.playGame.ariaLabel', 'GENERAL')}
              tabIndex={0}
            />
          </li>
          <li>
            <button
              onClick={() => {
                window.location.href = __t('buttons.hmHome.url', 'GENERAL');
              }}
              className="cta-btn-link"
              aria-label={__t('buttons.hmHome.ariaLabel', 'GENERAL')}
              tabIndex={0}
              role="link"
            >
              {__t('buttons.hmHome.label', 'GENERAL')}
            </button>
          </li>
        </ul>
        <div className="copyright-text">{__t('byLine.text', 'GENERAL')}</div>
      </div>
    </section>
  );
};

export default Disclaimer;
